export interface IFormStructure {
    description: string;
    name: string;
    title: string;
    fields: IFormField[];
    presentation: IFormPresentation;
    export_file?: string;
    export_status?: ExportStatus;
    export_requested_at?: string;
    order?: number;
    algorithm?: string;
}
export interface IFormField {
    name: string;
    label: string;
    description: string;
    omitted: boolean;
    hidden: boolean;
    order: number;
    indexed: boolean;
    data_type: FieldType;
    meta_data: IFormType;
    presentation: IFormPresentation;
    metadata?: Metadata;
    suggested_name: string;
    parent: string;
    key?: string;
}
export type FieldType =
    | 'char'
    | 'id'
    | 'text'
    | 'integer'
    | 'float'
    | 'date'
    | 'datetime'
    | 'none'
    | 'select'
    | 'file'
    | 'group';
export interface Metadata {
    type?: string;
    min?: number;
    max?: number;
    max_length?: number;
    min_length?: number;
    separator?: string;
    items?: string | string[][];
    choice_source?: string;
    restricted?: boolean;
    pattern?: string;
}
export interface IFormType {
    Integer: {
        type: string;
        min: number;
        max: number;
    };
    Float: {
        type: string;
        min: number;
        max: number;
    };
    DateTime: {
        type: string;
    };
    Date: {
        type: string;
    };
    Char: any;
    Choice: any;
}
export interface IFormPresentation {
    schema: string;
    required: boolean;
    invisible: boolean;
    choice_source: string;
    allow_other: boolean;
    link?: IGroupOfFields;
    hasDescription?: boolean;
    rtl?: boolean;
    hasPrecedingBreakLine?: boolean;
    displayType?: NonDataTypes | SelectDisplayType;
    selectType?: SelectTypes;
    alignment?: 'right' | 'left' | 'center';
    groups: IGroupOfFields[];
    mediaUrl?: string;
}
export interface IGroupOfFields {
    group: string;
    position: string;
    type?: string;
}
export interface IForm {
    metadata?: Metadata;
    presentation?: IFormPresentation;
    value: string;
    name: string;
    handleChangeVisible?: HandleChangeVisible;
    formValues?: { [key: string]: string | string[] | SelectValue };
    noAccess?: boolean;
}
export enum NonDataTypes {
    'title',
    'description'
}
export enum SelectTypes {
    'single',
    'multi',
    'Boolean'
}
export enum SelectDisplayType {
    'Dropdown' = 1,
    'Toggle' = 2,
    'Radio Button' = 3,
    'Checkbox' = 4
}
export interface SelectProps {
    name: string;
    value: SelectValue | string;
    items: string | string[][];
    separator: string;
    restricted: boolean;
    min?: number;
    max?: number;
    required?: boolean;
    handleChangeVisible?: HandleChangeVisible;
    formValues: { [key: string]: string | string[] | SelectValue };
}
export interface SelectValue {
    choices: string[] | string[][];
    others?: string[];
}
export interface SelectHandle {
    selectedOptions?: string[][];
    handleSelect: Function;
    handleToggleOption?: Function;
    handleClick?: Function;
    isOtherOptionEnabled?: Boolean;
    options: string[][];
    errorOtherOption?: Boolean;
    name?: string;
    value: SelectValue | string | string[];
    min?: number;
    max?: number;
    required?: boolean;
    presentation?: IFormPresentation;
    otherOptionValue?: string;
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    noAccess?: boolean;
}

export interface IEntry {
    structure: {
        name: string;
        title: string;
        description: string;
        order: number;
        export_file?: string;
        export_status?: ExportStatus;
        export_requested_at?: string;
    };
    readonly id: number;
    subject_id: number;
    readonly created: string;
    readonly modified: string;
    content: Object;
}
export type ExportStatus = 'empty' | 'doing' | 'generated';

export interface IMedia {
    uploadedLink: string;
    status: MediaStatus;
}
export type MediaStatus = 'uploading' | 'error';

export type HandleChangeVisible = (fieldName: string, visible: boolean) => void;
